// Firestore cannot store an array directly inside an array ("Nested arrays are not supported") nor undefined
// values. Review documents have both: drawn lines keep points as [[t, Hz], ...]. Found by the rule tests on the Mac
// (8 Oct 2026): a live save would have failed. Before saving, each inner array becomes {__a: [...]} and undefined
// fields are dropped; after reading, {__a} becomes an array again. Server values (serverTimestamp) pass unchanged.
const plain = (v) => v !== null && typeof v === 'object' && Object.getPrototypeOf(v) === Object.prototype;

export function toFirestore(v, inArray = false) {
  if (Array.isArray(v)) {
    const out = v.map((x) => (x === undefined ? null : toFirestore(x, true)));
    return inArray ? { __a: out } : out;
  }
  if (plain(v)) {
    const o = {};
    Object.entries(v).forEach(([k, x]) => { if (x !== undefined) o[k] = toFirestore(x, false); });
    return o;
  }
  return v;
}

export function fromFirestore(v) {
  if (Array.isArray(v)) return v.map(fromFirestore);
  if (plain(v)) {
    const keys = Object.keys(v);
    if (keys.length === 1 && keys[0] === '__a' && Array.isArray(v.__a)) return v.__a.map(fromFirestore);
    const o = {};
    keys.forEach((k) => { o[k] = fromFirestore(v[k]); });
    return o;
  }
  return v;
}
